import { useMe } from "@/data/user.ts";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import ROUTES from "@/config/routes.ts";
import { ACADEMY_ACCESS_KEY, ACCESS_EVENT_CODE } from "@/utils/agenda.ts";
import { Cookies } from "typescript-cookie";

const EVENT_BASE_URL = import.meta.env.EDS_EVENT_ACCESS_BASE_URL;
const AccessEventLink = () => {
  const { me } = useMe();
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    if (!me) return;
    if (!params?.base64) {
      navigate(ROUTES.home, { replace: true });
      return;
    }

    localStorage.setItem(ACCESS_EVENT_CODE, params.base64);

    const authTk = Cookies.get(ACADEMY_ACCESS_KEY);

    if ((!me.item.user.token && authTk == undefined) || authTk == null) {
      navigate(ROUTES.login, { replace: true });
      return;
    }

    let base64 = localStorage.getItem(ACCESS_EVENT_CODE);

    if (!base64) {
      navigate(ROUTES.home, { replace: true });
      return;
    }

    try {
      base64 = atob(base64.slice(3, -3));
    } catch (er) {
      base64 = atob(base64);
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment
    const eventId = JSON.parse(base64)?.event_id;

    if (typeof eventId == "number") {
      localStorage.removeItem(ACCESS_EVENT_CODE);
      if (typeof authTk === "string") {
        window.location.href = `${EVENT_BASE_URL}${eventId}?auth=${btoa(
          authTk,
        )}`;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, me]);

  return null;
};

export default AccessEventLink;
